module.exports = __webpack_public_path__ + "static/media/6.0d4350bf.jpg";